import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { requestApi } from '../../../../api/Api';
import { getPractices } from '../../../../api/Practice';

export const usePractice = ({ practice_id, options } = {}) => {
  const navigate = useNavigate();
  return useQuery(['practice', practice_id], () => getPractices(navigate, { practice_id }), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};

export const updatePractice = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/update',
    params,
    throwError: true
  });
